type LogoAccountLike = {
  id?: string;
  name?: string;
  bank?: string;
  ifsc?: string;
  logoUrl?: string;
};

type BankIconRegistryItem = {
  fileName: string;
  aliases: string[];
};

const bankIconBaseUrl = `${process.env.PUBLIC_URL || ""}/bank-icons`;

const bankIconRegistry: BankIconRegistryItem[] = [
  {
    fileName: "bharat.svg",
    aliases: ["bharat", "bharat ops", "fa bharat", "fa bharat ops"],
  },
  {
    fileName: "pnb.svg",
    aliases: ["pnb", "punb", "punjab national", "punjab national bank"],
  },
  {
    fileName: "kotak-bank.svg",
    aliases: ["kotak", "kotak bank", "kotak mahindra", "kotak mahindra bank"],
  },
];

const normalizeLogoText = (value: unknown) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const bankIconUrl = (fileName: string) => `${bankIconBaseUrl}/${fileName}`;

export const payoutBankLogoFor = (account: LogoAccountLike) => {
  const text = normalizeLogoText(
    [account.bank, account.name, account.id, account.ifsc].filter(Boolean).join(" "),
  );
  const match = bankIconRegistry.find((item) =>
    item.aliases.some((alias) => text.includes(normalizeLogoText(alias))),
  );

  return match ? bankIconUrl(match.fileName) : account.logoUrl || "";
};
